import { IQuoteServiceVariableServiceMock } from './quote-service-variable.mock.types';

export const mockQuoteServiceVariableService = (): IQuoteServiceVariableServiceMock => ({
  fetchQuoteServiceVariables: jest.fn(),

  fetchQuoteServiceVariable: jest.fn(),

  createQuoteServiceVariable: jest.fn(),

  updateQuoteServiceVariable: jest.fn(),

  deleteQuoteServiceVariable: jest.fn()
});
